import React, { useState } from "react";
import { Modal, Button, Checkbox } from "antd";
import snapDtaTermsHtml from "./termsandconditions";

const SignatureModalSnap = ({ setData }) => {
  const [isTermsModalOpen, setIsTermsModalOpen] = useState(false);
  const [consentDTA, setConsentDTA] = useState(false);
  const [consentPathways, setConsentPathways] = useState(false);

  const showTermsModal = () => {
    setIsTermsModalOpen(true);
  };

  const handleTermsModalClose = () => {
    setIsTermsModalOpen(false);
  };

  const handleConsentDTAChange = (e) => {
    setConsentDTA(e.target.checked);
    setData("consentDTA", e.target.checked);
  };

  const handleConsentPathwaysChange = (e) => {
    setConsentPathways(e.target.checked);
    setData("consentPathways", e.target.checked);
  };

  return (
    <div>
      <div className="signature-info-links">
        <p className="consent-statement">
          By signing, you consent to{" "}
          <a className="external-link" href="https://link-health.org/privacy-policy/" target="_blank" rel="noopener noreferrer">
            link Health's privacy and data sharing policy
          </a>{" "}
          and{" "}
          <Button type="link" onClick={showTermsModal} className="info-link">
            SNAP Terms and Conditions.
          </Button>
        </p>
      </div>

      {/* Terms and Conditions Modal */}
      <Modal
        title="Terms and Conditions"
        open={isTermsModalOpen}
        onCancel={handleTermsModalClose}
        footer={null}
        width={800}
        className="terms-modal"
        bodyStyle={{
          padding: "24px",
          maxHeight: "90vh",
          overflowY: "auto",
        }}
      >
        <div dangerouslySetInnerHTML={{ __html: snapDtaTermsHtml }} />
      </Modal>

      {/* Consent checkboxes for the signature modal */}
      <div className="consent-section">
        <div className="consent-checkbox-container">
          <Checkbox required className="consent-checkbox" checked={consentDTA} onChange={handleConsentDTAChange}>
            I allow DTA and the SNAP Outreach partner organization named in Section 3 to share information about my DTA benefits, including my TAFDC, EAEDC and/or SNAP case and countable expenses that
            may impact my benefits.
          </Checkbox>
        </div>
        <div className="consent-checkbox-container">
          <Checkbox required className="consent-checkbox" checked={consentPathways} onChange={handleConsentPathwaysChange}>
            I allow DTA and the DTA Pathways to Work provider (SNAP Path to Work, TAFDC Pathways to Work and/or Secure Jobs provider) named in Section 3 to share information about my DTA benefits
            including TAFDC, EAEDC and/or SNAP case to determine my eligibility for the DTA Pathways to Work programs. I also allow the sharing of information about my participation and progress in
            the program.
          </Checkbox>
        </div>
        By signing below, I also give permission for DTA to get records about my employment status from other state agencies, federal agencies and from other employment verification sources.
      </div>
    </div>
  );
};

export default SignatureModalSnap;
